import { Component, OnInit } from '@angular/core';
import {
  AnimationEvent,
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { PanelScrollingService } from '../../services/panel-scrolling.service';

/**
 * Used to display the panels of the dashboard, with a convenient way to navigate between the panels.
 * */
@Component({
  selector: 'campfire-panels',
  templateUrl: './panels.component.html',
  styleUrls: ['./panels.component.scss'],
  animations: [
    trigger('activePage', [
      // None is only ever used by the AppComponent in case the page gets resized from mobile to desktop view.
      state('none', style({
        left: ''
      })),

      state('image-feed', style({
        left: '-100vw'
      })),

      state('news', style({
        left: '-200vw'
      })),

      state('events', style({
        left: '-300vw'
      })),

      state('faq', style({
        left: '-400vw'
      })),

      transition('* <=> *', [
        animate('500ms ease-out')
      ]),
    ])
  ]
})
export class PanelsComponent implements OnInit {
  isIntroFinished: boolean = false;

  isIntroSkipped: boolean = false;

  activePageState: string = '';

  isShowingSalesDetails: boolean = false;

  constructor(private panelScrolling: PanelScrollingService) {

  }

  ngOnInit(): void {
    this.isIntroSkipped = window.localStorage.getItem('introSkipped') === 'true';

    if (!this.isIntroSkipped) {
      setTimeout(() => {
        this.isIntroFinished = true;
        window.localStorage.setItem('introSkipped', 'true');
      }, 7500);
    }

    this.panelScrolling.move.subscribe(page => {
      this.activePageState = page;
    });

    this.panelScrolling.toggleSales.subscribe(show => {
      this.isShowingSalesDetails = show;
    });
  }
}

